import React, { useEffect, useState, useMemo, useRef, forwardRef } from 'react';
import { RootStateOrAny } from 'react-redux';
import { useSelector } from 'react-redux';
import TableHeader from './Header';
import Pagination from './Pagination';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { getSalesData } from '../../services/SalesService';
import Loader from '../../components/Shared/Loader';
import moment from 'moment';
import Select from 'react-select';
import { getAllFilters } from '../../services/DataService';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import ExportDropdown from '../ExportDropdown';
import ExportPopup from '../ExportPopup';
import ColumnResizer from 'react-table-column-resizer';
import EntitySelector from '../EntitySelector';
import { getUniqueEntityList } from '../../helpers/utilities';
import DatePicker from 'react-datepicker';
import './index.scss';
import 'react-datepicker/dist/react-datepicker.css';

const channelOptions = [
  //{ label: "All", value: 1 },
  { label: "Stores", value: '2' },
  { label: "Online", value: '3' },

];

const channelOptionsPopUp = [
  { label: "All", value: '1' },
  { label: "Stores", value: '2' },
  { label: "Online", value: '3' },

];
const DataTable = (props: any) => {
  const isUpdated = useRef({ dateRange: false, selectedMarket: false });
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const customDate: any = new Date()?.setDate(new Date()?.getDate() - 1);
  const [salesData, setSalesData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sorting, setSorting] = useState({ field: '', order: '' });
  const [showLoader, setShowLoader] = useState(false);
  const [searchName, setSearchName] = useState('');
  const [currentDate, setCurrentDate] = useState(customDate);
  const [dateRange, setDateRange] = useState({
    fromDate: new Date(customDate)?.setMonth(new Date(customDate)?.getMonth() - 1),
    toDate: customDate,
  })
  //const [marketsList, setMarketsList] = useState<any[]>([]);
  const [selectedStore, setSelectedStore] = useState<any | null>(null);
  const [storesList, setStoresList] = useState<any[]>([]);
  const [selectedMarketFilter, setSelectedMarketFilter] = useState<any | null>(null);
  const [marketFilterList, setMarketFilterList] = useState<any[]>([]);
  const [categoriesList, setCategoriesList] = useState<any[]>([]);
  const [brandsList, setBrandsList] = useState<any[]>([]);
  const [selectedMarket, setSelectedMarket] = useState<any[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<any[]>([]);
  const [selectedBrand, setSelectedBrand] = useState<any[]>([]);
  const [rowExpand, setRowExpand] = useState(false);
  const [rowId, setRowId] = useState('');
  const [totalSalesData, setTotalSalesData] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const partnerDetail = useSelector((state: RootStateOrAny) => state.partner);
  const [exportFileName, setExportFileName] = useState('');
  const [exportLevelSelected, setExportLevelSelected] = useState('');
  const [selectedEntity, setSelectedEntity] = useState<any[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [selectedBusinessModelId, setSelectedBusinessModelId] = useState('');
  const [uniqueEntityList, setUniqueEntityList] = useState<any[]>([]);
  const [selectedChannel, setSelectedChannel] = useState<any | null>(null);
  const [showExport, setShowExport] = useState(false);
  const [emptyMessage, setEmptyMessage] = useState<any>('Please use above filtering to get your performance data.');
  const [showError, setShowError] = useState(false);
  const [notifyText, setNotifyText] = useState('');
  const [beautySalesAccessLevel, setBeautySalesAccessLevel] = useState('');
  let partnerId: string | null = '';
  const categoryId: string = selectedCategoryId;
  const businessModelId: string = selectedBusinessModelId;
  const [selectedChannelValue, setSelectedChannelValue] = useState('');
  const portfolioBrand: any = JSON.parse(sessionStorage.getItem('portfolioBrand')!);

  if (partnerDetail && partnerDetail.partner && Object.keys(partnerDetail?.partner)?.length !== 0) {
    partnerId = partnerDetail.partner.partnerId;
  } else {
    partnerId = window.sessionStorage.getItem('partnerId');
  }

  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';
  const yearsBack = selectedBusinessModelId === "10001" && selectedCategoryId === "10003" ? 1 : 2;

  const exportToCSV = (apiData, fileName, exportLevel) => {
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const handleDateChange = (date: any, target: any) => {
    setCurrentPage(1);
    setSearchName('');
    setSelectedBrand([]);
    setSelectedCategory([]);
    setSelectedMarketFilter([]);
    setSelectedStore([]);
    if (target === 'from') {
      setDateRange((prev) => ({
        ...prev,
        fromDate: date,
      }));
    } else {
      setDateRange((prev) => ({
        ...prev,
        toDate: date,
      }));
    }
  };

  const getFilters = () => {
    getAllFilters()
      .then(function (data) {
        let markets: any = [];
        for (let market of data.markets) {
          let marketData: any = { value: market.marketId, label: market.marketName };
          markets.push(marketData);
        }
        const matchedBeautyPartner = data?.beautySalesPartner?.find(
          (partner: any) => String(partner?.partnerId) === String(partnerId)
        );
        const beautySalesAccessLevel = matchedBeautyPartner?.salesLevel || '';
        setBeautySalesAccessLevel(beautySalesAccessLevel);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const exportLevel = [
    {
      label: 'Article Level',
      value: '1',
    },
    {
      label: 'Variant Level',
      value: '2',
    },
  ];

  const handleExportLevel = (selectedOption: any) => {
    setExportLevelSelected(selectedOption.value);
    let pd = parseDataForExport(finalSalesData, selectedOption.value);
    setTotalSalesData(pd);
    exportToCSV(pd, exportFileName, selectedOption.label);
    setIsSearch(true);
  };

  const handleCategory = (selectedOption: any) => {
    setCurrentPage(1);
    setSelectedCategory(selectedOption);
    setIsSearch(true);
  };

  const handleMarketFilter = (selectedOption: any) => {
    setCurrentPage(1);

    const allVariants = salesData?.flatMap(
      (item: any) => item.variants || []
    );

    if (!selectedOption) {
      setSelectedMarketFilter(null);

      const sortedStores = uniqueArray(allVariants, 'store_Name')
        ?.filter(Boolean)
        ?.sort((a: any, b: any) =>
          a.label.localeCompare(b.label)
        );

      setStoresList(sortedStores);
      return;
    }

    if (selectedChannel?.label === 'Stores') {
      const filteredAndSortedStores = uniqueArray(
        allVariants.filter(
          (x: any) => x.market === selectedOption.label
        ),
        'store_Name'
      )
        ?.filter(Boolean)
        ?.sort((a: any, b: any) =>
          a.label.localeCompare(b.label)
        );

      setStoresList(filteredAndSortedStores);
    }

    setSelectedStore([]);
    setSelectedMarketFilter(selectedOption);
  };



  const handleMarket = (selectedOption: any) => {
    setCurrentPage(1);
    setSearchName('');
    setSelectedBrand([]);
    setSelectedCategory([]);
    setSelectedMarket(selectedOption);
    setIsSearch(false);
  };

  const handleEntity = (selectedOption: any) => {
    const entityValues = selectedOption?.value?.split(':');
    setSelectedCategoryId(entityValues?.[1]);
    setSelectedBusinessModelId(entityValues?.[0]);
    props.handleSelectedBusinessModelId(entityValues?.[0]);
    props.handleSelectedCategoryId(entityValues?.[1]);
    setSelectedEntity(selectedOption);
  };

  const handleExportClose = () => {
    setShowExport(false);
  }

  const handleBrand = (selectedOption: any) => {
    setCurrentPage(1);
    setSelectedBrand(selectedOption);
    setIsSearch(true);
  };

  const handleStore = (selectedOption: any) => {
    setCurrentPage(1);
    setSelectedStore(selectedOption);
    setIsSearch(true);
  };


  const handleChange = (event: any) => {
    setSearchName(event.target.value);
    setCurrentPage(1);
    setIsSearch(true);
  };

  const handleChannel = (selectedOption: any) => {
    let channelValues = selectedOption?.value;
    setCurrentPage(1);
    setSearchName('');
    setSelectedBrand([]);
    setSelectedCategory([]);
    setSelectedStore([]);
    setSelectedMarketFilter([]);
    setSelectedChannel(selectedOption);
    setSelectedChannelValue(selectedOption?.value);
    props.handleSelectedChannelValue(selectedOption?.value);
    setIsSearch(false);
  }

  const handleRowExpand = (id: any) => {
    if (!document.getElementById(id)) {
      setRowExpand(true);
      setRowId(id);
    } else {
      setRowExpand(false);
      setRowId('');
    }
  };

  const getEntityList = (): any => {
    let entityList: any = getUniqueEntityList();
    setUniqueEntityList(entityList);
    props.handleUniqueEntityList(entityList);
    if (entityList?.length === 1) {
      handleEntity(entityList?.[0]);
    }
  };

  useEffect(() => {
    getFilters();
    getEntityList();
  }, []);

  const ITEMS_PER_PAGE = 100;

  const headers = [
    { name: 'Article Name', tooltip: 'Name of the article.', field: 'article_Name', sortable: true },
    !(selectedBusinessModelId === '10001' && categoryId === '10003') &&
    {
      name: 'Article Description',
      tooltip: 'Description of the article, usually the colour name.',
      field: 'article_Description',
      sortable: true,
    },
    selectedBusinessModelId === '10001'
      ? { name: 'Brand Name', tooltip: 'Name of the brand of the article.', field: 'brandName', sortable: true }
      : { name: '', field: '', sortable: true },
    selectedBusinessModelId === '10002' && JSON.parse(JSON.stringify(selectedMarket))?.label === 'All'
      ? { name: 'Market', tooltip: 'Name of the market of the article.', field: 'market', sortable: true }
      : { name: '', field: '', sortable: true },
    rowExpand && !(selectedBusinessModelId === '10001' && categoryId === '10003') && { name: 'Size', tooltip: 'Size', field: 'size', sortable: true },
    rowExpand && { name: 'GTIN', tooltip: 'Common identifier of the article.', field: 'gtin', sortable: true },
    { name: 'Category', tooltip: 'The category of the article.', field: 'category', sortable: true },
    {
      name: 'Orders',
      tooltip: 'Number of customer orders/purchases within selected time period.',
      field: 'order_count',
      sortable: true,
    },
    {
      name: 'Sold Items',
      tooltip: 'Number of sold items within selected time period.',
      field: 'no_of_Sold_Items',
      sortable: true,
    },
    {
      name: 'Sold Items After Return',
      tooltip:
        'Number of sold items after returns within selected time period. Please note that if you have higher returns than sales within selected date range, a negative number will be shown.',
      field: 'no_of_Sold_Items_After_Return',
      sortable: true,
    },
    selectedBusinessModelId === '10001' ?
      { name: 'Net Sales (SEK)', tooltip: 'Net Sales (SEK)', field: 'net_Sales', sortable: true }
      : { name: '', field: '', sortable: true },
    {
      name: 'Stock',
      tooltip: 'Current stock level for this article. Not affected by time period selection.',
      field: 'stock',
      sortable: true,
    },
    selectedBusinessModelId === '10002' ?
      rowExpand && { name: 'Return Reason', tooltip: 'Reason(s) for return.', field: 'return_Reason', sortable: true }
      : { name: '', field: '', sortable: true },
    {
      name: 'Return Rate',
      tooltip: 'No of sold items divided by number of returned items within selected time period.',
      field: 'return_Rate',
      sortable: true,
    },
    selectedBusinessModelId === '10002'
      ? { name: 'Approval Rate', tooltip: 'Rate of accepted orders', field: 'approval_Rate', sortable: true }
      : { name: '', field: '', sortable: true },
    selectedBusinessModelId === '10002'
      ? {
        name: 'Approval Delay',
        tooltip: 'Average time for a shop to accept or refuse an order (in seconds)',
        field: 'approval_Delay',
        sortable: true,
      }
      : { name: '', field: '', sortable: true },
  ];

  useEffect(() => {
    const newFromDate = new Date(customDate)?.setMonth(new Date(customDate)?.getMonth() - 1);
    const newToDate = customDate;
    const newCurrentDate = customDate;
    setDateRange({ fromDate: newFromDate, toDate: newToDate });
    setCurrentDate(newCurrentDate);
  }, [selectedBusinessModelId]);

  useEffect(() => {
    if (showExport) {
      // Clear filters that should not affect the export
      setSearchName('');
      setSelectedCategory([]);
      setSelectedBrand([]);
      setSelectedMarketFilter([]);
      setSelectedStore([]);
      setSorting({ field: '', order: '' }); // Optional: clear sorting if needed
    }
  }, [showExport]);

  useEffect(() => {
    if (!selectedEntity) return;

    setSalesData([]);
    setCurrentPage(1);
    setSearchName('');
    setSelectedBrand([]);
    setSelectedCategory([]);
    setSelectedStore([]);
    setSelectedMarketFilter([]);
    setSelectedMarket([]);
    setIsSearch(false);

    setEmptyMessage('Please use above filtering to get your performance data.');
  }, [selectedEntity]);

  useEffect(() => {
    const startDate = moment(dateRange?.fromDate).format('YYYY-MM-DD');
    const endDate = moment(dateRange?.toDate).format('YYYY-MM-DD');
    const channel =
      selectedBusinessModelId === '10001'
        ? JSON.parse(JSON.stringify(selectedChannel))?.label
        : undefined;

    const canFetch =
      startDate &&
      endDate &&
      (selectedBusinessModelId === '10002' || channel)
      && (uniqueEntityList.length == 1 || (uniqueEntityList.length > 1 && selectedEntity));

    if (!canFetch) {
      return;
    }

    const getData = () => {
      setShowLoader(true);
      getSalesData(
        partnerId,
        startDate,
        endDate,
        portfolioBrand.value,
        selectedBusinessModelId,
        channel,
        selectedCategoryId
      )
        .then((response: any) => {

          const data = Array.isArray(response?.data) ? response.data : [];
          setShowLoader(false);
          setSalesData(data);
          setCategoriesList(uniqueArray(data, 'category'));
          setBrandsList(uniqueArray(data, 'brandName'));
          const allVariants = data?.flatMap((item: any) => item.variants || []);
          const sortedMarketList = uniqueArray(allVariants, 'market')
            ?.filter(Boolean)
            ?.sort((a: any, b: any) =>
              a.label.localeCompare(b.label)
            );
          const sortedStoresList = uniqueArray(allVariants, 'store_Name')
            ?.filter(Boolean)
            ?.sort((a: any, b: any) =>
              a.label.localeCompare(b.label)
            );

          setMarketFilterList(sortedMarketList);
          setStoresList(sortedStoresList);
          setIsSearch(false);

          if (data.length == 0) {
            setEmptyMessage('No data found');
          }
          if (response?.status !== 204 && response?.status !== 200) {
            if (response?.detail) {
              setNotifyText(response?.detail);
              setShowError(true);
              setTimeout(() => setShowError(false), 7000);
            }
          }
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            setNotifyText(error?.response?.statusText);
            setShowError(true);
            setTimeout(() => setShowError(false), 7000);
          }
        });
    };

    if (dateRange) isUpdated.current.dateRange = true;
    if (selectedMarket) isUpdated.current.selectedMarket = true;

    if (isUpdated.current.dateRange && isUpdated.current.selectedMarket) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        if (
          startDate &&
          endDate &&
          (channel || (channel === undefined && selectedBusinessModelId === '10002'))
        ) {
          getData();
          isUpdated.current = { dateRange: false, selectedMarket: false };
        }
      }, 300);
    }
  }, [selectedEntity, dateRange, selectedChannel]);



  const uniqueArray = (data: any, value: any) => {
    let dataSet: any = [];
    let uniqueData: any = [];
    for (let item of data) {
      dataSet.push(item?.[value]);
    }
    const uniqueFilter = dataSet.filter(function (item: any, i: any, ar: any) {
      return ar.indexOf(item) === i;
    });
    for (let item of uniqueFilter) {
      let modifiedData: any = { value: item, label: item };
      uniqueData.push(modifiedData);
    }
    return uniqueData;
  };

  //Parse data for export to CSV
  const parseDataForExport = (data: any, level: any = 1) => {
    let pd: any = [];

    if (level === '1') {
      for (let sales of data) {
        let parsedSales: any = {};
        parsedSales['Article name'] = sales.article_Name;
        parsedSales['Article Description'] = sales.article_Description;
        if (businessModelId === '10001') {
          parsedSales['Brand name'] = sales.brandName;
        }
        parsedSales['GTIN'] = sales.gtin;
        parsedSales['Category'] = sales.category;
        parsedSales['Orders'] = sales.order_count;
        parsedSales['Sold items'] = sales.no_of_Sold_Items;
        parsedSales['Sold items after return'] = sales.no_of_Sold_Items_After_Return;
        parsedSales['Stock'] = sales.stock;
        // parsedSales['Return Reason'] = sales?.return_Reason
        //   ?.replaceAll('Unknown,', '')
        //   ?.replaceAll(',Unknown', '')
        //   ?.replaceAll('Unknown', '');
        parsedSales['Return rate'] = sales?.return_Rate ? sales?.return_Rate + '%' : '0%';
        if (businessModelId === '10002') {
          parsedSales['Approval Rate'] = sales?.approval_Rate ? Math.floor(sales?.approval_Rate * 100) + '%' : '';
        }
        if (businessModelId === '10002') {
          parsedSales['Approval Delay'] = sales?.approval_Delay ? secondsToHms(sales?.approval_Delay) : '';
        }

        pd.push(parsedSales);
      }
    } else if (level === '2') {
      for (let sales of data) {
        if (sales?.variants?.length > 0) {
          for (let variant of sales.variants) {
            let parsedSales: any = {};
            parsedSales['Article name'] = sales.article_Name;
            if (businessModelId === '10001' && selectedCategoryId === '10003') {
              parsedSales['Article Id'] = variant.productSku;
            }
            parsedSales['Article Description'] = sales.article_Description;
            if (businessModelId === '10001') {
              parsedSales['Brand name'] = sales.brandName;
            }
            if (selectedBusinessModelId === '10002' && JSON.parse(JSON.stringify(selectedMarket))?.label === 'All') {
              parsedSales['Market'] = variant.market;
            }
            parsedSales['Size'] = variant.size;
            parsedSales['GTIN'] = variant.gtin;
            parsedSales['Category'] = sales.category;
            parsedSales['Orders'] = variant.order_count;
            parsedSales['Sold items'] = variant.no_of_Sold_Items;
            parsedSales['Sold items after return'] = variant.no_of_Sold_Items_After_Return;
            if (businessModelId === '10001') {
              parsedSales['Net sales (SEK)'] = variant.net_Sales;
            }
            parsedSales['Stock'] = variant.stock;
            // parsedSales['Return Reason'] = variant.return_Reason;
            parsedSales['Return rate'] = variant.return_Rate;
            if (businessModelId === '10002') {
              parsedSales['Approval Rate'] = variant.approval_Rate;
            }
            if (businessModelId === '10002') {
              parsedSales['Approval Delay'] = variant.approval_Delay;
            }
            if (businessModelId === '10001' && selectedCategoryId === '10003' && beautySalesAccessLevel === 'Stores') {
              parsedSales['Store Id'] = variant.store_Id;
            }
            if (businessModelId === '10001') {
              parsedSales['Channel'] = variant.channel;
              parsedSales['Market'] = variant.market;
              if (
                portfolioBrand?.value !== '2' &&
                portfolioBrand?.value !== '3' &&
                !(portfolioBrand?.value === '1' && selectedCategoryId === '10002')
              ) {
                parsedSales['Store Name'] = variant.store_Name;
              }
            }

            pd.push(parsedSales);
          }
        }
      }
    }

    return pd;
  };

  const combineVariants = (
    data: any[],
    filterFn: (variant: any) => boolean,
    hasMarket: boolean,
    hasStore: boolean
  ) => {
    return data
      .map((sale) => {
        const filteredVariants = sale.variants?.filter(filterFn) || [];

        if (filteredVariants.length === 0) return null;

        // 🔹 GROUP BY productSku
        const groupedBySku: Record<string, any[]> = {};

        filteredVariants.forEach((v) => {
          if (!groupedBySku[v.productSku]) {
            groupedBySku[v.productSku] = [];
          }
          groupedBySku[v.productSku].push(v);
        });

        const combinedVariants = Object.values(groupedBySku).map((variants) => {
          if (variants.length === 1) return variants[0];

          const combined = variants.reduce(
            (acc, v) => {
              acc.net_Sales += v.net_Sales || 0;
              acc.no_of_Sold_Items += v.no_of_Sold_Items || 0;
              acc.no_of_Sold_Items_After_Return += v.no_of_Sold_Items_After_Return || 0;
              acc.order_count += v.order_count || 0;
              acc.stock += v.stock || 0;
              const rate =
                (acc.no_of_Sold_Items > 0
                  ? ((acc.no_of_Sold_Items -
                    acc.no_of_Sold_Items_After_Return) /
                    acc.no_of_Sold_Items) *
                  100
                  : 0) || 0;

              acc.return_Rate =
                Number(rate) === 0
                  ? '0%'
                  : `${Number(rate.toFixed(2))}%`;

              return acc;
            },
            {
              ...variants[0],
              net_Sales: 0,
              no_of_Sold_Items: 0,
              no_of_Sold_Items_After_Return: 0,
              order_count: 0,
              stock: 0,
              return_Rate: '0%',
            }
          );

          // // 🔹 Set combined labels
          // if (hasMarket && !hasStore) {
          //   combined.store_Name = 'Combined store';
          // }

          // if (hasStore && !hasMarket) {
          //   combined.market = 'Combined market';
          // }

          // if (hasMarket && hasStore) {
          //   combined.market = 'Combined market';
          //   combined.store_Name = 'Combined store';
          // }

          // if (!hasMarket && !hasStore) {
          //   combined.market = null;
          //   combined.store_Name = null;
          // }


          return combined;
        });

        const totals = combinedVariants.reduce(
          (acc, v) => {
            acc.net_Sales += v.net_Sales || 0;
            acc.no_of_Sold_Items += v.no_of_Sold_Items || 0;
            acc.no_of_Sold_Items_After_Return += v.no_of_Sold_Items_After_Return || 0;
            acc.order_count += v.order_count || 0;
            acc.stock += v.stock || 0;
            acc.return_Rate = Number(
              ((acc.no_of_Sold_Items > 0
                ? ((acc.no_of_Sold_Items - acc.no_of_Sold_Items_After_Return) / acc.no_of_Sold_Items) * 100
                : 0
              ) || 0).toFixed(2)
            );
            return acc;
          },
          {
            net_Sales: 0,
            no_of_Sold_Items: 0,
            no_of_Sold_Items_After_Return: 0,
            order_count: 0,
            stock: 0,
            return_Rate: 0,
          }
        );

        return {
          ...sale,
          market: null,
          store_Name: null,
          variants: combinedVariants,
          ...totals,
        };
      })
      .filter(Boolean);
  };

  const finalSalesData = useMemo(() => {
    if (!salesData || salesData.length === 0) {
      return [];
    }

    let computedSalesData: any[] = salesData as any[];

    if (searchName) {
      computedSalesData =
        computedSalesData &&
        computedSalesData.filter(
          (sales: any) =>
            sales.article_Name.toLowerCase().includes(searchName.toLowerCase()) ||
            sales?.articleID?.toLowerCase().includes(searchName.toLowerCase()) ||
            sales?.variants?.some((variant: any) => variant?.gtin?.toLowerCase().includes(searchName.toLowerCase())),
        );
    }

    if (selectedCategory && Object.keys(selectedCategory)?.length > 0) {
      const selectedCategoryValue = JSON.parse(JSON.stringify(selectedCategory))?.value;
      computedSalesData =
        computedSalesData &&
        computedSalesData?.filter((sales: any) =>
          sales?.category?.toLowerCase().includes(selectedCategoryValue.toLowerCase()),
        );
    }

    if (selectedBrand && Object.keys(selectedBrand)?.length > 0) {
      const selectedBrandValue = JSON.parse(JSON.stringify(selectedBrand))?.value;
      computedSalesData =
        computedSalesData &&
        computedSalesData.filter((sales: any) =>
          sales?.brandName?.toLowerCase().includes(selectedBrandValue.toLowerCase()),
        );
    }

    const hasMarket = selectedMarketFilter && Object.keys(selectedMarketFilter).length > 0;
    const hasStore = selectedStore && Object.keys(selectedStore).length > 0;

    const marketValue = hasMarket
      ? JSON.parse(JSON.stringify(selectedMarketFilter))?.label?.toLowerCase()
      : null;

    const storeValue = hasStore
      ? JSON.parse(JSON.stringify(selectedStore))?.value?.toLowerCase()
      : null;

    computedSalesData = combineVariants(
      computedSalesData,
      (variant: any) => {
        if (!marketValue && !storeValue) {
          return true;
        }

        if (marketValue && storeValue) {
          return (
            variant.market?.toLowerCase() === marketValue &&
            variant.store_Name?.toLowerCase().includes(storeValue)
          );
        }

        if (marketValue) {
          return variant.market?.toLowerCase() === marketValue;
        }

        if (storeValue) {
          return variant.store_Name?.toLowerCase().includes(storeValue);
        }

        return true;
      },
      hasMarket,
      hasStore
    );

    setTotalItems(computedSalesData?.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === 'asc' ? 1 : -1;
      computedSalesData =
        computedSalesData &&
        computedSalesData.sort((a: any, b: any) => {
          // check for num vs num
          if (typeof a[sorting.field] === 'number' && typeof b[sorting.field] === 'number') {
            return reversed * a[sorting.field] - b[sorting.field];
          }
          // check for string vs string
          if (typeof a[sorting.field] === 'string' && typeof b[sorting.field] === 'string') {
            if (sorting.field === 'return_Reason') {
              if (
                a[sorting.field]?.replaceAll('Unknown,', '')?.replaceAll(',Unknown', '')?.replaceAll('Unknown', '') <
                b[sorting.field]?.replaceAll('Unknown,', '')?.replaceAll(',Unknown', '')?.replaceAll('Unknown', '')
              )
                return reversed * -1;
              else return reversed * 1;
            } else {
              if (a[sorting.field] < b[sorting.field]) return reversed * -1;
              else return reversed * 1;
            }
          }
          return 0;
        });
    }

    const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
    const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

    //Add complete data for export
    let pd = parseDataForExport(computedSalesData);
    setTotalSalesData(pd);

    let m =
      selectedMarket && Object.keys(selectedMarket)?.length > 0
        ? ' - ' + JSON.parse(JSON.stringify(selectedMarket))?.label
        : '';
    let c =
      selectedCategory && Object.keys(selectedCategory)?.length > 0
        ? ' - ' + JSON.parse(JSON.stringify(selectedCategory))?.label
        : '';
    let b =
      selectedBrand && Object.keys(selectedBrand)?.length > 0
        ? ' - ' + JSON.parse(JSON.stringify(selectedBrand))?.label
        : '';

    setExportFileName(
      moment(dateRange?.fromDate).format('DD MMM YYYY') + ' - ' + moment(dateRange.toDate).format('DD MMM YYYY') + m + c + b,
    );


    if (
      selectedEntity &&
      Object.keys(selectedEntity)?.length > 0 &&
      dateRange?.fromDate &&
      dateRange.toDate &&
      selectedBusinessModelId === '10001' &&
      selectedChannel &&
      Object.keys(selectedChannel)?.length > 0
    ) {
      setEmptyMessage('No data found');
    }

    //Current Page slice
    return computedSalesData?.slice(indexOfFirstItem, indexOfLastItem);
  }, [salesData, currentPage, searchName, sorting, selectedCategory, selectedBrand, selectedStore, selectedMarketFilter]);

  const secondsToHms = (d) => {
    d = Number(d);
    const h = Math.floor(d / 3600);
    const m = Math.floor((d % 3600) / 60);
    const s = Math.floor((d % 3600) % 60);

    const hDisplay = h > 0 ? h + (h == 1 ? ' hour, ' : ' hours, ') : '';
    const mDisplay = m > 0 ? m + (m == 1 ? ' minute, ' : ' minutes, ') : '';
    const sDisplay = s > 0 ? s + (s == 1 ? ' second' : ' seconds') : '';
    return hDisplay + mDisplay + sDisplay;
  };

  const CustomDatepickerInput = forwardRef<any, any>(({ label, value, onClick }, ref) => (
    <button className="customDatepickerInput" onClick={onClick} ref={ref}>
      {label}: {moment(value).format('DD MMM YYYY')}
    </button>
  ));

  return (
    <>
      <div className="row w-100 dataTableContainer">
        <div className="col mb-3 col-12">
          <Row className="customPadding export">
            {finalSalesData?.length > 0 && selectedBusinessModelId === '10002' ?
              <Col xs={3} sm={3} md={3}>
                <ExportDropdown onChange={handleExportLevel} data={exportLevel} />
              </Col> : ''}
            {selectedBusinessModelId === '10001' ?
              <Col xs={3} sm={3} md={3}>
                <div className="dropdown-header" onClick={() => setShowExport(true)} data-testid="exportButton">
                  <i className="icon-Download"></i>
                  <span className="text">Export</span>
                </div>
                {showExport ? <ExportPopup
                  partnerId={partnerId}
                  channelOptions={channelOptionsPopUp}
                  selectedBusinessModelId={selectedBusinessModelId}
                  currentDate={currentDate}
                  onClose={handleExportClose}
                  CustomDatepickerInput={CustomDatepickerInput}
                  categoryId={selectedCategoryId}
                /> : ''}
              </Col> : ''}
          </Row>
          <Row key="SearchHeader">
            {uniqueEntityList.length > 1 ? (
              <Col xs={3} sm={3} md={3} className="customPadding market">
                <EntitySelector handleEntity={handleEntity} dataTable></EntitySelector>
              </Col>
            ) : null}
            {selectedBusinessModelId && selectedBusinessModelId === '10001' ?
              <Col xs={3} sm={3} md={3} className="customPadding channel">
                <Select
                  isSearchable
                  value={selectedChannel}
                  onChange={handleChannel}
                  options={channelOptions}
                  placeholder="Channel"
                />
              </Col>
              : null}
            {selectedBusinessModelId == '10002' ||
              selectedBusinessModelId == '10001' && selectedChannelValue
              ? (
                <>
                  <Col xs={3} sm={3} md={3} className="customPadding" style={{ marginBottom: '10px' }}>
                    <DatePicker
                      selected={dateRange?.fromDate}
                      onChange={(date) => handleDateChange(date, 'from')}
                      minDate={new Date(new Date().setFullYear(new Date().getFullYear() - yearsBack))}
                      maxDate={currentDate}
                      customInput={<CustomDatepickerInput label="From" />}
                      closeOnScroll={true}
                      showMonthDropdown
                      useShortMonthInDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </Col>

                  <Col xs={3} sm={3} md={3} className="customPadding">
                    <DatePicker
                      selected={dateRange?.toDate}
                      onChange={(date) => handleDateChange(date, 'to')}
                      minDate={dateRange?.fromDate}
                      maxDate={currentDate}
                      customInput={<CustomDatepickerInput label="To" />}
                      closeOnScroll={true}
                      showMonthDropdown
                      useShortMonthInDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </Col>
                </>
              ) : null}
          </Row>

          <Row key="SearchHeaderSubSection">
            {isSearch || finalSalesData?.length >= 1 ? (
              <Col xs={3} sm={3} md={3} className="customPadding">
                <div className="form-group has-search">
                  <span className="icon-Search form-control-search"></span>
                  <input
                    type="text"
                    value={searchName}
                    className="form-control"
                    placeholder="Article Name or GTIN"
                    onChange={handleChange}
                  />
                </div>
              </Col>
            ) : null}
            {isSearch || finalSalesData?.length >= 1 ? (
              <Col xs={2} sm={2} md={2} className="customPadding category">
                <Select
                  isClearable
                  isSearchable
                  value={selectedCategory}
                  onChange={handleCategory}
                  options={categoriesList}
                  placeholder="Category"
                />
              </Col>
            ) : null}
            {(isSearch || finalSalesData?.length >= 1) && businessModelId === '10001' ? (
              <Col xs={2} sm={2} md={2} className="customPadding brand">
                <Select
                  isClearable
                  isSearchable
                  value={selectedBrand}
                  onChange={handleBrand}
                  options={brandsList}
                  placeholder="Brand"
                />
              </Col>
            ) : null}
            {(isSearch || finalSalesData?.length >= 1) ? (
              <Col xs={2} sm={2} md={2} className="customPadding marketFilter">
                <Select
                  isClearable
                  isSearchable
                  value={selectedMarketFilter}
                  onChange={handleMarketFilter}
                  options={marketFilterList}
                  placeholder="Market"
                />
              </Col>
            ) : null}
            {((isSearch || finalSalesData?.length >= 1) &&
              businessModelId === '10001' &&
              JSON.parse(JSON.stringify(selectedChannel))?.label === 'Stores' &&
              portfolioBrand?.value !== '2' &&
              portfolioBrand?.value !== '3' &&
              !(portfolioBrand?.value === '1' && selectedCategoryId === '10002') &&
              !(portfolioBrand?.value === '1' && selectedCategoryId === '10003' && beautySalesAccessLevel !== 'Stores')) ? (
              <Col xs={2} sm={2} md={2} className="customPadding store">
                <Select
                  isClearable
                  isSearchable
                  value={selectedStore}
                  onChange={handleStore}
                  options={storesList}
                  placeholder="Store"
                />
              </Col>
            ) : null}
          </Row>
          {finalSalesData?.length > 0 ? (
            <>
              <div className="dataTable">
                <table className="table responsive">
                  <TableHeader headers={headers} onSorting={(field: any, order: any) => setSorting({ field, order })} />
                  <tbody>
                    {finalSalesData &&
                      finalSalesData?.map((sales: any, index: any) => (
                        <React.Fragment key={'airtcle' + index}>
                          <tr onClick={() => handleRowExpand(sales?.article_Name + index)} key={'articleLevel' + index}>
                            <td>
                              <i
                                className={
                                  rowId === sales?.article_Name + index && rowExpand
                                    ? 'icon-Arrows-Up'
                                    : 'icon-Arrows-Down'
                                }
                              />
                            </td>
                            <td>
                              {sales?.url ? (
                                <img src={sales?.url} width="24" height="36" />
                              ) : (
                                <img src={sales?.url} width="24" height="36" className="hiddenVisibility" />
                              )}
                            </td>
                            <td>{sales?.article_Name}</td>
                            <ColumnResizer className="columnResizer" />
                            {!(selectedBusinessModelId === '10001' && categoryId === '10003') &&
                              <>
                                <td>{sales?.article_Description}</td>
                                <ColumnResizer className="columnResizer" />
                              </>
                            }
                            {businessModelId === '10001' ? (
                              <>
                                <td>{sales?.brandName}</td> <ColumnResizer className="columnResizer" />{' '}
                              </>
                            ) : null}
                            {selectedBusinessModelId === '10002' &&
                              JSON.parse(JSON.stringify(selectedMarket))?.label === 'All' ? (
                              <>
                                <td>{sales?.market}</td> <ColumnResizer className="columnResizer" />{' '}
                              </>
                            ) : null}
                            {rowExpand && (
                              <>
                                {!(selectedBusinessModelId === '10001' && categoryId === '10003') &&
                                  <>
                                    <td>{sales?.size}</td>
                                    <ColumnResizer className="columnResizer" />
                                  </>
                                }
                                <td>{sales?.gtin}</td>
                                <ColumnResizer className="columnResizer" />
                              </>
                            )}
                            <td>{sales?.category}</td>
                            <ColumnResizer className="columnResizer" />
                            <td>{sales?.order_count}</td>
                            <ColumnResizer className="columnResizer" />
                            <td>{sales?.no_of_Sold_Items}</td>
                            <ColumnResizer className="columnResizer" />
                            <td>{sales?.no_of_Sold_Items_After_Return}</td>
                            <ColumnResizer className="columnResizer" />
                            {businessModelId === '10001' ? (
                              <>
                                <td>{sales?.net_Sales}</td> <ColumnResizer className="columnResizer" />
                              </>
                            ) : null}
                            <td>{sales?.stock}</td> <ColumnResizer className="columnResizer" />
                            {rowExpand && businessModelId === '10002' ? (
                              <>
                                <td>
                                  {sales?.return_Reason
                                    ?.replaceAll('Unknown,', '')
                                    ?.replaceAll(',Unknown', '')
                                    ?.replaceAll('Unknown', '')}
                                </td>
                                <ColumnResizer className="columnResizer" />
                              </>
                            ) : null}
                            <td>{sales?.return_Rate ? sales?.return_Rate + '%' : '0%'}</td>
                            <ColumnResizer className="columnResizer" />
                            {businessModelId === '10002' ? (
                              <>
                                <td>{sales?.approval_Rate ? Math.floor(sales?.approval_Rate * 100) + '%' : ''}</td>{' '}
                                <ColumnResizer className="columnResizer" />
                              </>
                            ) : null}
                            {businessModelId === '10002' ? (
                              <>
                                <td>{sales?.approval_Delay ? secondsToHms(sales?.approval_Delay) : ''}</td>{' '}
                                <ColumnResizer className="columnResizer" />
                              </>
                            ) : null}
                          </tr>
                          {rowId === sales?.article_Name + index && rowExpand ? (
                            <tr
                              id={sales?.article_Name + index}
                              key={'rowExpand' + index}
                              style={{ display: 'contents' }}
                            >
                              {sales?.variants?.map((variant: any, index: any) => (
                                <tr key={variant?.ecc_Variant_Code + index + 'rowExpandValue'}>
                                  <td></td>
                                  <td></td>
                                  <td>{sales?.article_Name}</td>
                                  <ColumnResizer className="columnResizer" />
                                  {
                                    !(selectedBusinessModelId === '10001' && categoryId === '10003') &&
                                    <>
                                      <td>{sales?.article_Description}</td>
                                      <ColumnResizer className="columnResizer" />
                                    </>
                                  }
                                  {businessModelId === '10001' ? (
                                    <>
                                      <td>{sales?.brandName}</td> <ColumnResizer className="columnResizer" />
                                    </>
                                  ) : null}
                                  {selectedBusinessModelId === '10002' &&
                                    JSON.parse(JSON.stringify(selectedMarket))?.label === 'All' ? (
                                    <>
                                      <td>{variant?.market}</td> <ColumnResizer className="columnResizer" />{' '}
                                    </>
                                  ) : null}
                                  {rowExpand && (
                                    <>
                                      {
                                        !(selectedBusinessModelId === '10001' && categoryId === '10003') &&
                                        <>
                                          <td>{variant?.size}</td>
                                          <ColumnResizer className="columnResizer" />
                                        </>
                                      }
                                      <td>{variant?.gtin}</td>
                                      <ColumnResizer className="columnResizer" />
                                    </>
                                  )}
                                  <td>{sales?.category}</td>
                                  <ColumnResizer className="columnResizer" />
                                  <td>{variant?.order_count}</td>
                                  <ColumnResizer className="columnResizer" />
                                  <td>{variant?.no_of_Sold_Items}</td>
                                  <ColumnResizer className="columnResizer" />
                                  <td>{variant?.no_of_Sold_Items_After_Return}</td>
                                  <ColumnResizer className="columnResizer" />
                                  {businessModelId === '10001' ? (
                                    <>
                                      <td>{variant?.net_Sales}</td> <ColumnResizer className="columnResizer" />
                                    </>
                                  ) : null}
                                  <td>{variant?.stock}</td> <ColumnResizer className="columnResizer" />
                                  {rowExpand && businessModelId === '10002' ? (
                                    <>
                                      <td>
                                        {variant?.return_Reason
                                          ?.replaceAll('Unknown,', '')
                                          ?.replaceAll(',Unknown', '')
                                          ?.replaceAll('Unknown', '')}
                                      </td>
                                      <ColumnResizer className="columnResizer" />
                                    </>
                                  ) : null}
                                  <td>{variant?.return_Rate}</td>
                                  <ColumnResizer className="columnResizer" />
                                  {businessModelId === '10002' ? (
                                    <>
                                      <td>
                                        {sales?.approval_Rate ? Math.floor(sales?.approval_Rate * 100) + '%' : ''}
                                      </td>{' '}
                                      <ColumnResizer className="columnResizer" />
                                    </>
                                  ) : null}
                                  {businessModelId === '10002' ? (
                                    <>
                                      <td>{sales?.approval_Delay ? secondsToHms(sales?.approval_Delay) : ''}</td>{' '}
                                      <ColumnResizer className="columnResizer" />
                                    </>
                                  ) : null}
                                </tr>
                              ))}
                            </tr>
                          ) : null}
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>
              <Row className="pagination" key="Pagination">
                <Col xs={4} sm={4} md={4}></Col>
                <Col xs={4} sm={4} md={4} className="d-flex justify-content-center text-center">
                  {finalSalesData?.length > 0 ? (
                    <Pagination
                      total={totalItems}
                      itemsPerPage={ITEMS_PER_PAGE}
                      currentPage={currentPage}
                      onPageChange={(page: any) => setCurrentPage(page)}
                    />
                  ) : null}
                </Col>
                <Col xs={4} sm={4} md={4}></Col>
              </Row>
            </>
          ) : (
            <div className="mt-3 text-center">{emptyMessage}</div>
          )}
        </div>
      </div>
      {showLoader ? <Loader /> : ''}
      {showError ? (
        <div className="alert alert-danger show-failed">
          <strong>Error!</strong> {notifyText}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default DataTable;
